<div class="tooltip-container">
  <div class="info-icon" (mouseenter)="showTooltip = true" (mouseleave)="showTooltip = false">
    <svg id="Grupo_2471" data-name="Grupo 2471" xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="0 0 18 18">
      <defs>
        <clipPath id="clip-path">
          <rect id="Rectángulo_3480" data-name="Rectángulo 3480" width="18" height="18" fill="#8f8f99" />
        </clipPath>
      </defs>
      <g id="Grupo_2470" data-name="Grupo 2470" clip-path="url(#clip-path)">
        <path id="Trazado_1055" data-name="Trazado 1055"
          d="M9,0a9,9,0,1,0,9,9A9.011,9.011,0,0,0,9,0M9,16.313A7.313,7.313,0,1,1,16.313,9,7.321,7.321,0,0,1,9,16.313"
          fill="#8f8f99" />
        <path id="Trazado_1056" data-name="Trazado 1056"
          d="M8.375,3A3.5,3.5,0,0,0,5,6.282a.844.844,0,0,0,1.678.187C6.69,6.4,6.9,4.688,8.375,4.688c1.419,0,1.688.593,1.688,1.688a1.33,1.33,0,0,1-.889,1.271,2.332,2.332,0,0,0-1.642,2.1v.281a.844.844,0,0,0,1.688,0V9.75c0-.181.236-.4.563-.529A3.041,3.041,0,0,0,11.75,6.375C11.75,3.586,9.914,3,8.375,3"
          transform="translate(0.625 0.375)" fill="#8f8f99" />
        <path id="Trazado_1057" data-name="Trazado 1057"
          d="M8.125,11A1.125,1.125,0,1,0,9.25,12.125,1.125,1.125,0,0,0,8.125,11m0,1.125h0Z"
          transform="translate(0.875 1.375)" fill="#8f8f99" />
      </g>
    </svg>
  </div>

  <div class="tooltip" [class.tooltip-visible]="showTooltip">
    <div class="tooltip-content">
      <div class="tooltip-text">{{ tooltipText }}</div>
      @if (imageUrl) {
        <div class="tooltip-image">
          <img [src]="imageUrl" [alt]="imageAlt" />
        </div>
      }
    </div>
    <div class="tooltip-arrow"></div>
  </div>
</div>
